import React, { useState, useRef, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { fade, makeStyles, useTheme } from "@material-ui/core/styles";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonToolbar,
} from "reactstrap";

import { bindActionCreators } from 'redux';
import searchActions from '../../../../redux/actions/searchActions';

import ExportView from "./ExportView";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import {
  Tooltip,
  Drawer,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  Slide,
} from "@material-ui/core";
import FileExportIcon from "mdi-react/FileImportIcon";
import ExportSettingsForm from "./ExportSettingsForm";
import { Publisher } from "../../../../shared/pubsub/publisher.js";
import LinearLoading from "../../../../shared/components/LinearLoading";
import FileDocumentEditOutlineIcon from "mdi-react/FileDocumentEditOutlineIcon";
import { _getNeighborhoods } from "../../../../shared/helpers/apicalls";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import ChevronUpIcon from "mdi-react/ChevronUpIcon";
import LogoIcon from "mdi-react/StarBoxOutlineIcon";
import SummaryIcon from "mdi-react/FileDocumentEditOutlineIcon";
import DetailsIcon from "mdi-react/FormatListCheckboxIcon";
import SettingsIcon from "mdi-react/CogIcon";
import ChartIcon from "mdi-react/ChartAreasplineIcon";
import MapIcon from "mdi-react/MapMarkerIcon";
import ThemeIcon from "mdi-react/PaletteIcon";
import TimeIcon from "mdi-react/AvTimerIcon";
import EditIcon from "mdi-react/PencilIcon";
import PreviewIcon from "mdi-react/EyeOutlineIcon";
import RefreshIcon from "mdi-react/RefreshIcon";

import GeneralBuildingSearchBar from "../../../../shared/components/building_filters/GeneralBuildingSearchBar";
import RecentHistory from './RecentHistory';

import PropertyType from "../reportviews/reports/PropertyType";
import NewDev from "../reportviews/reports/NewDev";
import CondoReport from "../reportviews/reports/CondoReport";
import CoopReport from "../reportviews/reports/CoopReport";
import LuxuryReport from "../reportviews/reports/LuxuryReport";
import TownhouseReport from "../reportviews/reports/TownhouseReport";

import SocialMarketOverview from "../reportviews/social/SocialMarketOverview";
import SocialNewDev from "../reportviews/social/SocialNewDev";
import SocialLuxury from "../reportviews/social/SocialLuxury";
import SocialCondo from "../reportviews/social/SocialCondo";
import SocialCoop from "../reportviews/social/SocialCoop";
import SocialTownhouse from "../reportviews/social/SocialTownhouse";

import NewsletterMarketTrends from "../reportviews/newsletters/NewsletterMarketTrends";
import NewsletterNewDev from "../reportviews/newsletters/NewsletterNewDev";
import NewsletterLuxury from "../reportviews/newsletters/NewsletterLuxury";
import NewsletterCondo from "../reportviews/newsletters/NewsletterCondo";
import NewsletterCoop from "../reportviews/newsletters/NewsletterCoop";
import NewsletterTownhouse from "../reportviews/newsletters/NewsletterTownhouse";
import PostCardMarketTrends from "../reportviews/postcards/MarketOverview";
import PostCardNewDev from "../reportviews/postcards/NewDev";
import PostCardLuxury from "../reportviews/postcards/LuxuryReport";
import PostCardCondo from "../reportviews/postcards/CondoReport";
import PostCardCoop from "../reportviews/postcards/CoopReport";
import PostCardTownHouse from "../reportviews/postcards/TownhouseReport";
import BuildingMarketOverView from "../reportviews/buildingviewreport/PropertyType"


import CompPropertySelector from './CompPropertySelector';
import BuildingSearchSelector from './BuildingSearchSelector';
import PropertySelector from './PropertySelector';

import BuildingMarketProofView from "../reportviews/buildingviewreport1/PropertyType";
import  BuildingMarketProofViewComp from "../reportviews/propertycompreport/PropertyType"
import  NewsLetterComp from "../reportviews/newslettercompreport/PropertyType";

import VideoMarketReport from "../reportviews/video/PropertyType";

import HeyGenExportButton from "./HeyGenExportButton";
import SnackBar from '../../../../shared/components/SimpleSnackBar';


import Fab from "@material-ui/core/Fab";
import CloseIcon from "mdi-react/CloseIcon";

import { _isEqual } from "../../../../shared/helpers/utils";
import CustomDateComp from "../CustomDate/CustomDateComp.jsx";
import { findStyles } from "./utils.js";
import ZoomSlider from "./Slider";
const apiUrl = process.env.API_ROOT + "/";
const exportAPIURL = process.env.MP_EXPORT_SERVER;

const drawerWidth = 800; // Set the width of the drawer

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#780F9E !important",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    color: "#FFF !important",
    alignItems: "center",
    padding: "2px 15px",
  },
  appToolBar: {
    justifyContent: "space-between",
    width: "100% !important",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  toolBar: {
    paddingLeft: 0,
    paddingRight: 0,
    width: 1200,
    justifyContent: "center",
  },
  toolBarButtonGroup: {
    justifyContent: "end",
  },
  button: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#9600BF",
    margin: "0px 5px",
    minWidth: 100,
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    "&.activeButton": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#5C1F7A", // Slight background on hover
    },
  },
  fab: {
    fontWeight: 600,
    background: "#780F9E",
    width: 200,
    "&.Mui-disabled": {
      color: "#F5F7FA",
      background: "#DBE0E8",
    },
    "&:hover": {
      background: "#9600BF",
    },
  },
  fabClose: {
    fontWeight: 600,
    borderColor: "#780F9E",
    color: "#780F9E",
    background: "#FFF",
    marginLeft: "5px",
    "&.Mui-disabled": {
      color: "#F5F7FA",
      background: "#DBE0E8",
    },
    "&:hover": {
      background: "#F5F7FA",
    },
  },
  title: {
    textAlign: "left",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 100,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
    marginBottom: 0,
    minHeight: 0,
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }), // Use dynamic margin based on slider height
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },

  
}));




const searchBarStyles = makeStyles((theme) => ({
  searchBarContainer: {
    width: "100%",
    position: "fixed",
    left: 0,
    top: 60,
    padding: "30px 20px",
    zIndex: 99,
    background: "#78199E",
  },
  appBar: {
    backgroundColor: "#780F9E !important",
    transform: "none !important",
    color: "#FFF !important",
    boxShadow: "none",
    "&.MuiToolbar-gutters": {
      paddingRight: "0px !important",
    },
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: "-24px !important",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0, //theme.spacing(3),
      width: "100%",
      maxWidth: "none",
    },
    "& .c_input-tag": {
      background: "#780F9E",
      color: "#FFF",
    },
    "& .poly_map_launcher": {
      background: "#5C1F7A !important",
    },
    "&.MuiToolbar-gutters": {
      paddingRight: 0,
    },
    "& .mdi-icon": {
      fill: "#FFF",
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "#FFF !important",
    width: "100%",
    ".c_nav-input.MuiInputBase-input":{
      color:"#fff !important"
    }
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7) + " !important",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
    color: "#222 !important",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  searchButton: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#5C1F7A",
    margin: "0px 5px",
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    minWidth: 120,
    height: 46,
    marginLeft: -40,
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
    "&.Mui-disabled": {
      boxShadow: "none",
      color: "#9600BF",
    },
  },
}));

const searchBarBuildingStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor:'#F5F7FA !important',
    transform:'none !important',
    color:'#FFF !important',
    boxShadow:"none",
    padding: 'none !important',
    "& .MuiToolbar-gutters": {
      paddingRight: "0px !important",
      paddingLeft: "0px !important",
    },
    },
   
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      backgroundColor: " #FFF !important",
      border:"2px solid #333",
      marginRight: "0px !important",
      marginLeft: "0px !important",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: 0, //theme.spacing(3),
        width: "100%",
        maxWidth: "none",
      },
      "& .c_search-result-container":{
        boxShadow:"none",
        top:"50px"
      },
      "& .c_input-tag": {
        background: "#A3ADC2",
        color: "#FFF",
        "& .mdi-icon": {
          fill: "#FFF",
        },
      },
      "& .poly_map_launcher": {
        background: "#5C1F7A !important",
      },
      "&.MuiToolbar-gutters": {
        paddingRight: 0,
      },
      "& .mdi-icon": {
        fill: "#A3ADC2",
      },
      "& .c_search-nav": {
        color: "#A3ADC2",
        "& .c_nav-input.MuiInputBase-input":{
          color: "#A3ADC2",
        
        },
      
      },

    },
    searchIcon: {
      width: theme.spacing(7),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7) + " !important",
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "80%",
      },
      color: "#222 !important",
    },

    inputRoot: {
      color: 'inherit',
      width: '100%',
    },

    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    searchButton: {
      color: "#FFF",
      borderColor: "#FFF",
      backgroundColor: "#5C1F7A",
      margin: "0px 5px",
      "&:hover": {
        borderColor: "#FFF", // A darker shade for the hover state
        backgroundColor: "#B070CC", // Slight background on hover
      },
      minWidth: 120,
      height: 46,
      marginLeft: -40,
      boxShadow:
        "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
      "&.Mui-disabled": {
        boxShadow: "none",
        color: "#9600BF",
      },
    },
  }));
  export const searchBarStylesPurple = makeStyles(theme => ({
    appBar: {
    backgroundColor:'#780F9E !important',
    transform:'none !important',
    color:'#FFF !important'
    },
    ".MuiToolbar-regular":{
      paddingLeft:0,
      paddingRight:0
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: 0, //theme.spacing(3),
        width: '90%',
        maxWidth:800
      },
    },
    searchIcon: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7) + ' !important',
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '80%',
      },
      color:'#FFF !important'
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
}));
function formatDate() {
  const date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

const dateFormatted = formatDate();

const sanitizeResults = (result, paragraphs) => {
  let sanitized = result.replace(/undefined/g, "");

  // Remove leading newlines
  sanitized = sanitized.replace(/^\n+/, "");

  // Protect code blocks and inline code from being altered
  sanitized = sanitized.replace(
    /```([^```]*)```/gim,
    "<pre><code>$1</code></pre>"
  );
  sanitized = sanitized.replace(/`([^`]*)`/gim, "<code>$1</code>");

  // Headers
  sanitized = sanitized.replace(/^### (.*$)/gim, "<b>$1</b>");
  sanitized = sanitized.replace(/^## (.*$)/gim, "<b>$1</b>");
  sanitized = sanitized.replace(/^# (.*$)/gim, "<b>$1</b>");

  // Bold and italic
  sanitized = sanitized.replace(/\*\*\*(.+?)\*\*\*/gim, "<b><i>$1</i></b>");

  // Bold
  sanitized = sanitized.replace(/\*\*(.+?)\*\*/gim, "<b>$1</b>");

  // Italic
  sanitized = sanitized.replace(/\*(.+?)\*/gim, "<i>$1</i>");

  // Underline
  sanitized = sanitized.replace(/___(.+?)___/gim, "<u>$1</u>");

  // Links
  sanitized = sanitized.replace(/\[(.+?)\]\((.+?)\)/gim, '<a href="$2">$1</a>');

  // Blockquotes
  sanitized = sanitized.replace(/^\> (.*$)/gim, "<blockquote>$1</blockquote>");

  // Paragraph handling
  if (paragraphs) {
    sanitized = sanitized.replace(/(?:\n|\r|\n\n)+/g, "</p><p>");
    sanitized = `<p>${sanitized}</p>`;
  } else {
    sanitized = sanitized.replace(/(?:\n|\r|\n\n)+/g, "");
  }

  return sanitized;
};

const WritingInProgress = () => {
  const classes = useStyles();

  const phrases = [
    "Interpreting Trends",
    "Analyzing Data",
    "Compiling Insights",
    "Evaluating Metrics",
  ];
  const [currentPhrase, setCurrentPhrase] = useState(phrases[0]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentPhrase((prevPhrase) => {
        const currentIndex = phrases.indexOf(prevPhrase);
        const nextIndex = (currentIndex + 1) % phrases.length;
        return phrases[nextIndex];
      });
    }, 1000); // Change phrase every 2 seconds

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [phrases]);

  return (
    <Typography
      variant="h5"
      noWrap
      className={classes.drawerHeaderTitle}
      style={{ textAlign: "center" }}
    >
      <FileDocumentEditOutlineIcon
        size={32}
        color="#780F9E"
        style={{ marginTop: -5 }}
      />{" "}
      {currentPhrase}...
    </Typography>
  );
};
function defaultDate(building) {
  const now = moment();
  const startDate = building ? now.clone().subtract(1, "quarters").startOf("quarter") : now.clone().subtract(1, "month").startOf("month");
  const endDate = building ? now.clone().subtract(1, "quarters").endOf("quarter") : now.clone().subtract(1, "month").endOf("month");
  // const endDate = now.clone().startOf("month").utc();
  return {
    startDate,
    endDate,
  };
}
console.log(defaultDate(), "myModalClose");
function defaultPreviousPeriod(building) {
  const startDate = defaultDate(building).startDate.clone().subtract(1, "years");
  const endDate = defaultDate(building).endDate.clone().subtract(1, "years");

  return {
    startDate,
    endDate,
  };
}

const BuildingSearchScreen = (props) => {
  const { updateBuildingReport } = props;
  
  return  (<div
        style={{
          maxWidth: 900,
          margin: "0 auto",
         
        
          width:"100%",
          marginTop:180,
        }}
        >
        <h3
        style={{
          fontWeight:800,
          textAlign:"center",
          textTransform:"uppercase"
        }}
        >Search for a Building to Generate a Report</h3>
         <div
        style={{
          maxWidth: 900,
          
          margin: "0 auto",
          display: "flex",
          gap: 0,
          alignItems:"center"
        }}
      >
       
        <GeneralBuildingSearchBar
          buildingFilter={
            '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
          }
          handleSearch={updateBuildingReport}
          buildingAttributes={[]}
          placeHolder={
            "Address or Building Name"
          }
          addBuilding={false}
          buildingTab={null}
          hideBoroHood={true}
          hideAddIcon={true}
          hideMapDraw={true}
           searchBarStyles={searchBarBuildingStyles}
           exitMessageData={{title:"Report Unavailable", message:"Building reports are currently available for condos and co-ops.  Click continue if you would like to learn more about this property on our public website."}}
        />
       
      </div>
      <hr/>
      
      
      <RecentHistory {...props} handleSearch={updateBuildingReport} />
    </div>)
}

const ExportModal = (props) => {
  const {
    html,
    user: userProp,
    parentFetchInProgress,
    getUnitList,
    setDetails,
    reportParams,
    renderListViewHTML,
    renderStatsHTML,
    searchTags,
    _renderChartHTML,
    isModalOpen,
    toggleModal,
    reportComponent,
    layoutStyle,
    isHeaderAvailable,
    isFooterAvailable,
    reportItem,
    submit,
    setSubmit,
    isBuilding,
    setIsBuilding,
    isMedia,
    setIsMedia,
    setLayoutStyle
  } = props;
  
  
  
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [panel, setPanel] = useState(false);
  const [progress, setProgress] = useState("");
  const [orientation, setOrientation] = useState("portrait");
  const [preview, setPreview] = useState(false);
  const [fetchInProgress, setFetchInProgress] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [boundingBoxCoord, setBoundingBoxCoord] = useState([]);
  const [isBoundsAvailable, setIsBoundsAvailable] = useState(false);
  const [aiRun, setAiRun] = useState(false); // State to track if handleAI has been run
  const [aiInProgress, setAIInProgress] = useState(false);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [unitListProgress, setUnitListProgress] = useState(false);
  const [formValuesCheckboxes, setFormValuesCheckboxes] = useState([]);
  const previewContainerRef = useRef(null);
  const [renderedChart, setRenderChart] = useState(null);
  const [reportLoaded, setReportLoaded] = useState(false);
  const [reportData, setReportData] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedContent, setEditedContent] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showDateComp, setShowtDateComp] = useState(false);
  const [showBrandingSlider, setShowBrandingSlider] = useState(false);
  const [showThemeSlider, setShowThemeSlider] = useState(false);
  const [reportSearchTags, setReportSearchTags] = useState(searchTags);
  const [selectedFont, setSelectedFont] = useState("Roboto");
  const [AiResponse, setAiResponse]=useState(null)
  const [compSettings, setCompSettings] = useState(false);
  const [fetchAi, setFetchAi]=useState(false)
  const [sliderHeight, setSliderHeight] = useState(0);
  const [zoom, setZoom] = useState(reportItem && reportItem.defaultZoom ? reportItem.deafultZoom : 100);
  const prevSearchTagsRef = useRef();
  const prevItemProps = useRef();
  const isFirstRender = useRef(true);

  const [areaChanged, setAreaChanged] = useState(false);

  const searchBarRef = useRef(null);
  const dateBarRef = useRef(null);
  const brandingSliderRef = useRef(null);
  const themeSliderRef = useRef(null);
  let brandingFromStorage = localStorage.getItem("branding");
  const contactFromStorage = localStorage.getItem("contact");
  const themeFromStorage = localStorage.getItem("theme");
  const styleFromStorage = localStorage.getItem("style");
  const customColorFromStorage = localStorage.getItem("customColor");
  const customBGFromStorage = localStorage.getItem("customBackgroundColor");
  const customTextColorFromStorage = localStorage.getItem("customTextColor");
  console.log(Object.assign({}, reportItem));
  const isBuildingReport = reportItem && reportItem.isBuilding;
  const defaultValues = {
    reportTitle: "",
    summary: "",
    details: "no-details",
    branding:
      brandingFromStorage || (user && user.logo ? "mylogo" : reportItem && reportItem.marektproofBranding ? "marketproof" : "hide"),
    contact: contactFromStorage ? contactFromStorage : "show",
    style: styleFromStorage || "default",
    customColor: customColorFromStorage || "#F53246",
    theme: themeFromStorage || "default",
    customBackgroundColor: customBGFromStorage || "#fdfdfd",
    textColor: customTextColorFromStorage || "#333",
    dateOptions: {
      startDate: defaultDate(isBuildingReport).startDate,
      endDate: defaultDate(isBuildingReport).endDate,
      previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
      previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
      gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
      isCustomPreviousSelected: false,
      isPreviousSelectedClicked: false,
      isCurrentCustomSelected: false,
      anyChangeOccured: false,
    },
  };
  const [snackShow, setSnackShow]=useState(false);
  const [snackMessage, setSnackMessage]=useState(false);
  const [snackType, setSnackType]=useState('success');
 
console.log(defaultValues);
  const [color, setColor] = useState(
    customColorFromStorage || defaultValues.customColor
  );
  const [backgroundColor, setBackgroundColor] = useState(
    customBGFromStorage || defaultValues.customBackgroundColor
  );
  const [textColor, setTextColor] = useState(
    customTextColorFromStorage || defaultValues.textColor
  );

  const [formValues, setFormValues] = useState(defaultValues);
  const progressRef = useRef("");
  const iframeRef = useRef(null);
  const classes = useStyles();
  const searchClasses = searchBarStyles();
  const searchBuildingClasses=searchBarBuildingStyles()
  const theme = useTheme();
  const localStorageUser = localStorage.getItem("bl_user");
  const user = localStorageUser ? JSON.parse(localStorageUser) : userProp;

  // useEffect(()=>{
  //   localStorage.setItem("formValues", JSON.stringify(formValues));
  // },[formValues])
  const stateProps = {
    reportData,
    setReportData,
    fetchInProgress,
    setFetchInProgress,
    reportLoaded,
    setReportLoaded,
    formValues,
    color,
    setColor,
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
  };

  console.log(reportComponent, "reportComponent");
  const setIframeContent = (height) => {
    const iframe = iframeRef.current;
    if (iframe) {
      const iframeDoc = iframe.contentDocument;
      iframe.style.height = `${height}px`;
    }
  };

  const styles = Array.from(
    document.querySelectorAll('style, link[rel="stylesheet"]')
  )
    .map((style) => {
      let clonedStyle = style.cloneNode(true);
      if (clonedStyle.tagName.toLowerCase() === "link") {
        const linkElement = clonedStyle;
        const href = linkElement.getAttribute("href");
        const absoluteUrl = new URL(href, document.baseURI).href;
        linkElement.setAttribute("href", absoluteUrl);
      }
      return clonedStyle.outerHTML;
    })
    .join("\n");
  console.log(isBuilding, "isBuilding");
  const ReportHeader = () => {
    return (
      <div className="header page-section header-section">
        <div className="export-header">
          <div>
            {formValues &&
            formValues.branding &&
            formValues.branding === "mylogo" &&
            user &&
            user.logo ? (
              <img className="header-logo" src={user.logo} />
            ) : formValues &&
              formValues.branding &&
              formValues.branding === "marketproof" ? (
              <img
                className="header-logo"
                src="https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png"
              />
            ) : null}
          </div>
          <div>{ReportContact()}</div>
        </div>
      </div>
    );
  };

  const summarizeGeographies = (dataArray, shortVersion = false) => {
    // First, filter and prioritize boroughs
    const boroughs = dataArray
      .filter((item) => item.type === "borough")
      .map((item) => item.name.charAt(0).toUpperCase() + item.name.slice(1));

    // Then, gather the neighborhood names
    const neighborhoods = dataArray
      .filter((item) => item.type === "neighborhood")
      .map((item) => item.name.charAt(0).toUpperCase() + item.name.slice(1));

    // Finally, gather the building names
    const buildings = dataArray
      .filter((item) => item.type === "building")
      .map((item) => item.name.charAt(0).toUpperCase() + item.name.slice(1));

    // If there's a custom area (polygon), add a placeholder description for it
    const areas = dataArray
      .filter((item) => item.type === "area")
      .map(() => "Select Area");

    // Combine all lists with boroughs first, then neighborhoods, buildings, and areas
    const geographies = [...boroughs, ...neighborhoods, ...buildings, ...areas];

    // If there are more than 3 items, return the first two and "...and surrounding areas"
    if (geographies.length > 3) {
      return `${geographies[0]}, ${geographies[1]} and surrounding areas`;
    }

    // If shortVersion is true, return the first item and "and surrounding areas"
    if (shortVersion && geographies.length > 1) {
      return `${geographies[0]} and surrounding areas`;
    }

    // If there's more than one item, join them with commas and "and" before the last element
    if (geographies.length > 1) {
      return (
        geographies.slice(0, -1).join(", ") +
        " and " +
        geographies[geographies.length - 1]
      );
    }

    // If only one item, return it as is
    return geographies[0] || "";
  };

  //const ReportContent = <BlendedLayout {...props} {...stateProps} customDate={formValues} submit={submit} setSubmit={setSubmit}summarizeGeographies={summarizeGeographies} />

  const MyReportContent = () => {
    const componentsMap = {
      PropertyType: PropertyType,
      CondoReport: CondoReport,
      CoopReport: CoopReport,
      NewDev: NewDev,
      LuxuryReport: LuxuryReport,
      TownhouseReport: TownhouseReport,
      SocialMarketOverview: SocialMarketOverview,
      SocialNewDev: SocialNewDev,
      SocialLuxury: SocialLuxury,
      SocialCondo: SocialCondo,
      SocialCoop: SocialCoop,
      SocialTownhouse: SocialTownhouse,
      NewsletterMarketTrends: NewsletterMarketTrends,
      NewsletterNewDev: NewsletterNewDev,
      NewsletterLuxury: NewsletterLuxury,
      NewsletterCondo: NewsletterCondo,
      NewsletterCoop: NewsletterCoop,
      NewsletterTownhouse: NewsletterTownhouse,
      postCardNewDev: PostCardNewDev,
      postCardMarketTrend: PostCardMarketTrends,
      postCardLuxury: PostCardLuxury,
      postCardCondo: PostCardCondo,
      postCardCoop: PostCardCoop,
      postCardTownHouse: PostCardTownHouse,
       BuildingMarketOverView:BuildingMarketOverView,
      BuildingMarketProofView:BuildingMarketProofView,
      BuildingMarketProofViewComp:BuildingMarketProofViewComp,
      NewsLetterComp:NewsLetterComp,
      VideoMarketReport: VideoMarketReport
      
    };
  
    const Component = componentsMap[reportComponent];
  console.log(Component, "component")
    if (!Component) return null; // Return null if the component is not defined
  
    const commonProps = {
      ...props,
      ...stateProps,
      customDate: formValues,
      submit,
      setSubmit,
      summarizeGeographies,
      color,
      logo: user.logo,
      compSettings,
      setAiResponse,
      AiResponse,
      fetchAi,
      setFetchAi,
      setAIInProgress
    };
  
   
  console.log(fetchAi, "fetchAi")
    return <Component {...commonProps} />;
  };
  const ReportContent=MyReportContent()
  const ReportTitle = () => {
    if (!formValues || !formValues.reportTitle) return null;
    return (
      <div className="page-section">
        <div className="report-title">
          <h2>{formValues.reportTitle}</h2>
        </div>
      </div>
    );
  };

  const ReportSummary = () => {
    if (!formValues || !formValues.summary) return null;
    return (
      <div className="page-section">
        <div className="report-summary-container">
          <div className="report-summary">
            <div
              className="report-content"
              dangerouslySetInnerHTML={{ __html: formValues.summary }}
            />
          </div>
        </div>
      </div>
    );
  };

  const ReportFooter = () => {
    return null;
    return (
      <div className="page-section  footer-section">
        <div className="report-footer">
          Data by{" "}
          <a
            className="footer__logo"
            href={"https://marketproof.com/"}
            target="_blank"
          >
            <img
              src="https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png"
              style={{ width: 100 }}
            />
          </a>
          {" | "}
          {dateFormatted}
        </div>
      </div>
    );
  };

  const ReportLoading = () => {
    return (
      <div
        style={
          layoutStyle
            ? {
                position: "relative",
                background: "#F5F7FA",
                paddingTop: "35%",
                width: `${layoutStyle.width}px`,
                height: "100vh",
                marginTop: "1.8rem",
              }
            : {
                height: "100vh",
                borderBottom: "20px solid #f5f7fa",
                position: "relative",
                paddingBottom: "60px",
                background: "#F5F7FA",
                paddingTop: "35%",
                paddingLeft: "20%",
                paddingRight: "20%",
                marginTop: "1.8rem",
              }
        }
      >
        <div style={layoutStyle && { width: "70%", margin: "auto" }}>
          <LinearLoading />
          <h2
            style={{
              padding: 50,
              fontSize: 24,
              fontWeight: 600,
              textTransform: "uppercase",
            }}
          >
            <WritingInProgress />
          </h2>
        </div>
      </div>
    );
  };
console.log(reportLoaded, "reportLoaded")
  const ListHTML = () => {
    if (!formValues.listHTML) return <></>;
    if (formValues.details && formValues.details == "no-details") return <></>;
    return <>{formValues.listHTML}</>;
  };

  const ReportContact = () => {
    if (formValues && formValues.contact && formValues.contact === "show") {
      return (
        <div className="page-section">
          <div className="report-contact">
            <div
              className="avatar-img"
              style={{ backgroundImage: `url(${user.avatar})` }}
              alt="avatar"
            />

            <div>
              <p className="contact-name">
                {user.firstName} {user.lastName}
                <br />
              </p>
              <div className="contact-title">
                {user.title && <span>{user.title}</span>}
                {user.company && (
                  <span>
                    {" | "}
                    {user.company}
                  </span>
                )}

                {user.agentLicenseNumber && (
                  <span>
                    {" "}
                    {" | "}License #: {user.agentLicenseNumber}
                  </span>
                )}
              </div>
              <div className="contact-info">
                {user.email && <span>{user.email}</span>}
                {user.primaryPhone && (
                  <span>
                    {" | "}
                    {user.primaryPhone}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const headerContent = `
    <style>
    body {
      font-family: Arial, sans-serif;
    }
    .key-stat{
      font-size:30px !important;
    }
    .page-section{
      width:100%;
    }
    .export-header{
      padding: 20px 20px;
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      border-bottom: 1px solid #333;
      justify-content:space-between;
    }
    .report-contact{
      display:flex;
    }
    .report-contact .avatar-img {
      margin-right:10px;
    }
    .report-contact .contact-name{
      font-size:22px;
      font-weight:700;
      line-height:27px;
    }
    .report-contact .contact-title, .report-contact .contact-info{
      font-size:18px;
      font-weight:300;
      line-height:21px;
    }
    .report-contact .avatar-img{
      width:70px;
      height:70px;
      background-size:cover;
      border-radius:50%;
    }
    .report-title{
      margin:20px;
    }
    .report-summary-container{
      height:950px;
    }
    .report-summary{
      margin:20px;
      padding:20px;
      background:#F5F7FA;
      margin-bottom:30px;
    }
    .report-summary .report-content{
      font-size:20px;
      column-count:2;
    }
    .report-title h2{
      font-weight: 700;
      text-transform: uppercase;
      padding-bottom: 15px;
      border-bottom: 1px solid #AAA;
      margin-bottom: 30px;
    }
    .editable[contenteditable=true] {
      outline: 1px dashed #FF206E;
      position:relative;
    }
    .editable[contenteditable=true]:hover::before {
      content: "Click to Edit";
      text-transform:uppercase;
      background-color: #FF206E;
      color: #FFF;
      font-weight: bold;
      position: absolute;
      left: 0;
      font-size: 12px;
      line-height: 12px;
      padding: 8px 20px;
      text-align: center;
      height: 30px;
      top: 0;
      display: block;
      font-family: 'Montserrat';
      margin: 0;
      
    }
    .editable[contenteditable=true]:active::before, .editable[contenteditable=true]:focus::before{
      width:0;
      height:0;
      display:none;
    }
    @media print {
      body {
        transform: scale(1); /* Zoom to 80% */
      }
      .editable[contenteditable=true] {
        outline: none;
      }
    }
    </style>
    ${styles}
  `;

  const scripts = `
    <script src="https://cdnjs.cloudflare.com/ajax/libs/react/17.0.2/umd/react.production.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/react-dom/17.0.2/umd/react-dom.production.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/recharts/2.0.10/Recharts.min.js"></script>
  `;
  useEffect(() => {
    console.log("ExportModal reportLoaded", reportLoaded);
  }, [reportLoaded]);
  
  useEffect(() => {
    const isBuildingReport = reportItem && reportItem.isBuilding;
    setFormValues(Object.assign({}, formValues, { dateOptions: {
        startDate: defaultDate(isBuildingReport).startDate,
        endDate: defaultDate(isBuildingReport).endDate,
        previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
        previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
        gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
       
      }}))
      if(reportItem && reportItem.defaultZoom){
        setZoom(reportItem.defaultZoom)
      }
      
  }, [reportItem]);
  
  useEffect(() => {
    const eventSource = new EventSource(`${exportAPIURL}/events`);

    eventSource.onmessage = function (event) {
      const progress = JSON.parse(event.data);
      if (progressRef.current !== progress.status) {
        progressRef.current = progress.status;
        setProgress(`${progress.status}`);
      }
    };

    return () => {
      eventSource.close();
    };
  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const openDrawer = (panel) => {
    setPanel(panel);
    setIsDrawerOpen(!isDrawerOpen);
    setShowtDateComp(false);
  };

  const scrollToTop = () => {
    if (previewContainerRef.current) {
      //previewContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
      if (previewContainerRef.current.scrollTop > 0) {
        // Scroll to top
        previewContainerRef.current.scrollTop = 0;
      }
    }
  };

  const handleSaveChanges = (updatedContent) => {
    console.log(updatedContent);
    setEditedContent(updatedContent); // Save edited content
  };

  const handleToggleSearchBar = () => {
    setShowtDateComp(false);
    setShowThemeSlider(false);
    setShowBrandingSlider(false);
    setShowSearchBar(!showSearchBar);
  };
  const handleToggleDateBar = () => {
    setShowSearchBar(false);
    setShowThemeSlider(false);
    setShowBrandingSlider(false);
    setShowtDateComp(!showDateComp);
  };
  const handleToggleBrandingSlider = () => {
    setShowThemeSlider(false);
    setShowSearchBar(false);
    setShowtDateComp(false);
    setShowBrandingSlider(!showBrandingSlider);
  };

  const handleToggleThemeSlider = () => {
    setShowBrandingSlider(false);
    setShowSearchBar(false);
    setShowtDateComp(false);
    setShowThemeSlider(!showThemeSlider);
  };

  const closeAllSliders = () => {
    setShowBrandingSlider(false);
    setShowSearchBar(false);
    setShowtDateComp(false);
    setShowThemeSlider(false);
  };

  const isSliderOpen = () => {
    return (
      showSearchBar || showDateComp || showBrandingSlider || showThemeSlider
    );
  };

  const updateSliderHeight = () => {
    setTimeout(() => {
      let sliderHeight = 0;

      if (showSearchBar && searchBarRef.current) {
        sliderHeight = searchBarRef.current.offsetHeight;
      } else if (showDateComp && dateBarRef.current) {
        sliderHeight = dateBarRef.current.offsetHeight;
      } else if (showBrandingSlider && brandingSliderRef.current) {
        sliderHeight = brandingSliderRef.current.offsetHeight;
      } else if (showThemeSlider && themeSliderRef.current) {
        sliderHeight = themeSliderRef.current.offsetHeight;
      }

      setSliderHeight(sliderHeight);
    }, 100); // Delay calculation to wait for rendering
  };

  useEffect(() => {
    updateSliderHeight(); // Calculate the height on initial render and when toggling sliders
  }, [showSearchBar, showDateComp, showBrandingSlider, showThemeSlider]);

  const handleClickOutside = function (event) {
    var polyMapModal = document.querySelector(".poly_map__modal");
    var headerElement = document.querySelector("header"); // Assuming your header has a <header> tag. Adjust the selector if needed.
    var popOverElement = document.querySelector(".MuiPopover-root");
    var formControlElement = document.querySelector(".MuiFormControl-root");
    console.log("here");
    // Check if the click is outside the search bar, not within the .poly_map__modal, and not within the header
    if (
      searchBarRef.current &&
      !searchBarRef.current.contains(event.target) &&
      !(polyMapModal && polyMapModal.contains(event.target)) && // Prevent closing if clicked inside .poly_map__modal
      !(headerElement && headerElement.contains(event.target)) // Prevent closing if clicked inside the header
    ) {
      setShowSearchBar(false); // Close the slider if clicked outside
    }
    if (
      dateBarRef.current &&
      !dateBarRef.current.contains(event.target) &&
      !(popOverElement && popOverElement.contains(event.target)) &&
      !(headerElement && headerElement.contains(event.target)) // Prevent closing if clicked inside the header
    ) {
      setShowSearchBar(false); // Close the slider if clicked outside
      setShowtDateComp(false);
    }
    if (
      brandingSliderRef.current &&
      !brandingSliderRef.current.contains(event.target) &&
      !(headerElement && headerElement.contains(event.target))
    ) {
      setShowBrandingSlider(false);
    }

    if (
      !(formControlElement && formControlElement.contains(event.target)) &&
      themeSliderRef.current &&
      !themeSliderRef.current.contains(event.target) &&
      !(headerElement && headerElement.contains(event.target))
    ) {
      setShowThemeSlider(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the slider components
    const addOrRemoveClickListener = () => {
      if (
        showSearchBar ||
        showDateComp ||
        showBrandingSlider ||
        showThemeSlider
      ) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };

    addOrRemoveClickListener();

    // Attach click listener to the iframe content document when iframe is available
    const iframe = iframeRef.current;

    if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
      const iframeDoc = iframe.contentWindow.document;
      console.log("has iframe");

      // Attach the mousedown event initially
      const attachMouseDown = () => {
        iframeDoc.addEventListener("mousedown", (event) => {
          const clickEvent = new MouseEvent("mousedown", { bubbles: true });
          if (!editedContent) {
            closeAllSliders();
          }
        });
      };

      // Attach the event initially
      attachMouseDown();

      // Set up a MutationObserver to watch for content changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" || mutation.type === "subtree") {
            // Reattach the event after content changes
            attachMouseDown();
          }
        });
      });

      // Observe changes in the iframe document
      observer.observe(iframeDoc, { childList: true, subtree: true });

      // Disconnect the observer when no longer needed (e.g., on unmount)
      return () => observer.disconnect();
    }

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);

      if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.removeEventListener("mousedown", handleClickOutside);
      }
    };
  }, [
    showSearchBar,
    showDateComp,
    showBrandingSlider,
    showThemeSlider,
    iframeRef,
  ]);


  const updateReport = () => {
    setEditedContent(false);
    setReportData(false);
    setPreview(!preview);
    setAreaChanged(false);
    setSubmit(true);
    setReportSearchTags(searchTags);
    scrollToTop();
    setIsBuilding(false);
    setIsMedia(false)

  };
  const updateBuildingReport = () => {
    setEditedContent(false);
    setReportData(false);
    setPreview(!preview);
    setAreaChanged(false);
    setSubmit(true);
    setReportSearchTags(searchTags);
    scrollToTop();
    setIsBuilding(false);
    setIsMedia(false)
  };
  
  

  useEffect(() => {
    const fetchData = async () => {
      scrollToTop();
    };

    //fetchData();
  }, [
    formValues.details,
    ,
    formValues.branding,
    formValuesCheckboxes,
    props.user,
  ]);

  useEffect(() => {
    const loadCharts = async () => {
      if (
        formValuesCheckboxes.includes("showSnapshotBuildingCharts") &&
        formValues.details === "no-details"
      ) {
        setUnitListProgress(true);

        const resolvedHtml = await _renderChartHTML(); // Call the function that returns the promise
        setRenderChart(resolvedHtml);
        setUnitListProgress(false);
      }
    };

    loadCharts();
  }, [formValuesCheckboxes]);

  useEffect(() => {
    if (!isModalOpen) {
      //setReportLoaded(false);
    }
  }, [isModalOpen]);

  useEffect(() => {
    console.log(searchTags);
    if (isFirstRender.current) {
      // Skip the first render (initial hydration)
      isFirstRender.current = false;
      prevSearchTagsRef.current = searchTags; // Set the initial value of searchTags
      return;
    }

    const prevSearchTags = prevSearchTagsRef.current;
    if (!_isEqual(prevSearchTags, searchTags)) {
      setAreaChanged(true);
      setSubmit(true);
    }

    // Update the previous searchTags reference for next render
    prevSearchTagsRef.current = searchTags;
  }, [searchTags]);

  function calculateBoundingBox(polyHoods) {
    let minLng = Infinity,
      minLat = Infinity,
      maxLng = -Infinity,
      maxLat = -Infinity;

    polyHoods.forEach((polygon) => {
      polygon.coordinates.forEach((coord) => {
        const [lng, lat] = coord.map(Number); // Convert string to number
        if (lng < minLng) minLng = lng;
        if (lat < minLat) minLat = lat;
        if (lng > maxLng) maxLng = lng;
        if (lat > maxLat) maxLat = lat;
      });
    });

    return [
      [minLng, minLat],
      [maxLng, maxLat],
    ];
  }

  console.log(formValues, "formValuesSettingFormUpdated");
  const handleCopy = async (e) => {
    e.preventDefault();
    setProgress("Submitting...");
    
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
    const scriptParagraphs = iframeDoc.querySelectorAll("p.copy-script");
    const combinedText = Array.from(scriptParagraphs)
      .map(p => p.textContent.trim())
      .join("\n\n");
    
    try {
      await navigator.clipboard.writeText(combinedText);
      setProgress("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy:", err);
      setProgress("Failed to copy content.");
    }
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setProgress("Submitting...");
    
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    let htmlContent = iframeDoc.documentElement.outerHTML;
    let height = reportItem && reportItem.style && reportItem.style.height
      ? reportItem.style.height : null;
    
    let width = reportItem && reportItem.style && reportItem.style.width
      ? reportItem.style.width : null;
    
    if (
      (height === "auto") ||
      (width === "auto")
    ) {
      const updateDimensions = function () {
        const exportPage = iframeDoc.querySelector('.export-page');
        if (exportPage) {
          if (height === "auto" || !height) {
            height = exportPage.scrollHeight;
          }
          if (width === "auto" || !width) {
            width = exportPage.scrollWidth;
          }
      
          // Add 100px to the calculated height
          const adjustMargin = 50;
          const adjustedHeight = height + adjustMargin;
          height = adjustedHeight;
          iframe.style.height = `${(height + adjustMargin)}px`;
          exportPage.style.height = `${adjustedHeight}px`;
          htmlContent = iframeDoc.documentElement.outerHTML;
          
        }
      };
    
      if (iframeDoc.fonts && iframeDoc.fonts.ready) {
        await iframeDoc.fonts.ready.then(updateDimensions);
      } else {
        // fallback if fonts.ready unsupported
        await new Promise(resolve => setTimeout(() => {
          updateDimensions();
          resolve();
        }, 300));
      }
    }

    
    const uniqueId = uuidv4();
    const ext =
      reportItem && reportItem.downloadType && reportItem.downloadType
        ? reportItem.downloadType
        : "pdf";

    const fileName = `${user.id}/Marketproof-Download-${dateFormatted}-${uniqueId}.${ext}`;
    const exportName = `Marketproof-Download-${dateFormatted}-${uniqueId}.${ext}`;
    setExportInProgress(true);

    try {
      let response;
      if (
        reportItem &&
        reportItem.downloadType &&
        reportItem.downloadType == "png"
      ) {
        response = await fetch(`${exportAPIURL}/generate-image-save`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            html: htmlContent,
            format: "png",
            width: width,
            height: height,
          }),
        });
      } else if (
        reportItem &&
        reportItem.downloadType &&
        reportItem.downloadType == "zip"
      ) {
        response = await fetch(`${exportAPIURL}/generate-images-zip`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            html: htmlContent,
            format: "png",
            width: width,
            height: height,
          }),
        });
      } else {
        response = await fetch(`${exportAPIURL}/generate-pdf-save`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            html: htmlContent,
            orientation: "portrait",
            fileName,
          }),
        });
      }

      if (response.ok) {
        const { url } = await response.json();

        const fileResponse = await fetch(url);
        const blob = await fileResponse.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = exportName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);

        setProgress("Download complete");
        setTimeout(() => {
          console.log("Timeout triggered. Setting progress to null.");
          setProgress(null);
        }, 2000);
        setExportInProgress(false);
        const customData = {
          file: url,
          reportName : reportItem && reportItem.name ? reportItem.name : '',
          reportComponent: reportItem && reportItem.reportComponent ? reportItem.reportComponent : ''
        };
        Publisher.publish(`track-mp.aiMarketingCenterExport`, {
          user: user,
          customData: customData,
        });
      } else {
        console.error("Failed to generate PDF");
        setProgress("Error generating PDF");
        setExportInProgress(false);
      }
    } catch (error) {
      console.error("Error exporting PDF:", error);
      setProgress("Error generating PDF");
      setExportInProgress(false);
    }
  };

  const handleMapLoad = (loaded) => {
    setIsMapLoaded(loaded);
  };

  const getZoom = () => {
    const sliderValue = zoom;

    // Map the slider value (from any range, e.g., 10-200) to a zoom factor
    // Assuming slider range from 10 to 200
    const zoomValue = sliderValue / 100;

    // Round to the nearest 0.04 increment
    const roundedZoom = Math.round((zoomValue - 1) / 0.07) * 0.07 + 1;
    return roundedZoom;
  };

  const ext =
    reportItem && reportItem.downloadType && reportItem.downloadType
      ? reportItem.downloadType
      : "pdf";

  const sliderOpen = isSliderOpen();
  
  const snackClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }	
      setSnackShow(false);
      setSnackMessage(false);
  };
  const snackOpen = (message, type) => {
    setSnackShow(true);
    setSnackMessage(message);
    setSnackType(type);
  };
  return (
    <div>
      <SnackBar 
        snackShow={snackShow} 
        snackMessage={snackMessage} 
        snackClose={snackClose} 
        snackDuration={5000} 
        snackType={snackType} 
      />
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="lg"
        className={`modal-dialog pdf_export_modal`}
        ref={previewContainerRef}
      >
        <div style={{}}>
          <CssBaseline />
          <AppBar
            position="fixed"
            style={{ zIndex: 1201 }}
            className={classes.appBar}
          >
            <Toolbar className={classes.appToolBar}>
              <Typography
                variant="h6"
                noWrap
                className={classes.title}
                style={{ width: 200, justifyContent: "left" }}
              >
                Preview & Customize
              </Typography>
            {!isBuilding ?   
              
              ( <Toolbar className={classes.toolBar}>
                <Tooltip title="Upload your logo and change your contact method">
                  <Button
                    startIcon={<LogoIcon />}
                    className={`${classes.button} ${
                      showBrandingSlider ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleBrandingSlider}
                    disabled={fetchInProgress || fetchAi}
                  >
                    {user && user.logo ? "Brand" : "Brand"}
                    {showBrandingSlider ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>

                <Tooltip title="Select a theme to customize look and feel of your report">
                  <Button
                    startIcon={<ThemeIcon />}
                    className={`${classes.button} ${
                      showThemeSlider ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleThemeSlider}
                    disabled={fetchInProgress ||fetchAi}
                  >
                    Theme
                    {showThemeSlider ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>
                {reportItem && reportItem.isBuilding ? <></> : <Tooltip title="Change the borough, neighborhood or area of this report">
                  <Button
                    startIcon={<MapIcon />}
                    className={`${classes.button} ${
                      showSearchBar ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleSearchBar}
                    disabled={fetchInProgress || fetchAi || aiInProgress}
                  >
                    {reportItem && reportItem.isBuilding ? "Building" : "Area"}{" "}
                    {searchTags && searchTags.length > 0 ? (
                      <span className="small-text" style={{ marginLeft: 5 }}>
                        ({searchTags.length})
                      </span>
                    ) : null}{" "}
                    {showSearchBar ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>}
                {reportItem && reportItem.isBuilding && (reportItem.isBuilding == "comp" || reportItem.isBuilding == "coming-soon")  ? null :
                <Tooltip title="Choose time period for this report">
                  <Button
                    startIcon={<TimeIcon />}
                    className={`${classes.button} ${
                      showDateComp ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleDateBar}
                    disabled={fetchInProgress || fetchAi || aiInProgress}
                  >
                    Date{" "}
                    {showDateComp ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>}

                <Tooltip
                  title={
                    isEditMode
                      ? "Preview report - exit edit mode and remove dotted lines"
                      : "Edit report - editable content marked by dotted lines"
                  }
                >
                  <Button
                    startIcon={isEditMode ? <PreviewIcon /> : <EditIcon />}
                    className={`${classes.button} ${
                      isEditMode ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={() => setIsEditMode(!isEditMode)}
                    activated={isEditMode}
                    disabled={fetchInProgress || aiInProgress  || fetchAi}

                  >
                    {isEditMode ? "Preview" : "Copy"}
                  </Button>
                </Tooltip>
              </Toolbar> ):null}
              <div style={{ width: 200, textAlign: "right" }}>
                {/* <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={toggleDrawer}
                >
                  <ChevronLeftIcon color={"white"} />
                </IconButton> */}
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={() => {
                    if (sliderOpen) {
                      closeAllSliders();
                    } else {
                      toggleModal();
                      setFormValues({
                        ...formValues,
                        dateOptions: {
                          startDate: defaultDate(isBuildingReport).startDate,
                          endDate: defaultDate(isBuildingReport).endDate,
                          previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
                          previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
                          gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
                          isCustomPreviousSelected: false,
                          isPreviousSelectedClicked: false,
                          anyChangeOccured: false,
                        },
                      });
                      setIsBuilding && setIsBuilding(false);
                     setIsMedia && setIsMedia(false)
                      setReportData(null);
                      setAiResponse(null)
                      setFetchInProgress(false);
                      setFetchAi(false)
                      console.log("modalClose");
                    }
                  }}
                  style={{ marginLeft: 5 }}
                >
                  {sliderOpen ? (
                    <ChevronUpIcon size={18} color={"white"} />
                  ) : (
                    <CloseIcon size={20} color={"white"} />
                  )}
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <Slide direction="down" in={showSearchBar} mountOnEnter unmountOnExit>
            <div
              id="geo-search-bar"
              className={searchClasses.searchBarContainer}
              ref={searchBarRef}
            >
              <div
                style={{
                  maxWidth: 900,
                  margin: "0 auto",
                  display: "flex",
                  gap: 0,
                  alignItems: "center",
                }}
              >
              {reportItem && reportItem.isBuilding ? 
                <GeneralBuildingSearchBar
                  buildingFilter={
                    '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
                  }
                  handleSearch={updateBuildingReport}
                  buildingAttributes={[]}
                  placeHolder={
                    "Address or Building Name"
                  }
                  addBuilding={false}
                  buildingTab={null}
                  hideBoroHood={true}
                  hideAddIcon={true}
                  hideMapDraw={true}
                   searchBarStyles={searchBarStyles}
                   exitMessageData={{title:"Report Unavailable", message:"Building reports are currently only available for condos and co-ops.  Click continue if you would like to learn more about this property on our public website."}}
                />:
                <>
                  <GeneralBuildingSearchBar
                    buildingFilter={
                      '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
                    }
                    handleSearch={null}
                    buildingAttributes={[]}
                    placeHolder={
                      "Search for Borough, Neighborhood, or Use the Map"
                    }
                    addBuilding={true}
                    buildingTab={null}
                    hideBoroHood={false}
                    hideAddIcon={false}
                    hideMapDraw={false}
                    searchBarStyles={searchBarStyles}
                  />
                  <Tooltip title={"Rewrite report with the updated area"}>
                    <Button
                      startIcon={<RefreshIcon />}
                      className={searchClasses.searchButton}
                      onClick={updateReport}
                      disabled={!areaChanged || fetchAi}
                    >
                      Update
                    </Button>
                  </Tooltip>
                </>
              }
                
              </div>
            </div>
          </Slide>
          <Slide direction="down" in={showDateComp} mountOnEnter unmountOnExit>
            <div
              id="date-bar"
              className={searchClasses.searchBarContainer}
              ref={dateBarRef}
            >
              <div
                style={{
                  margin: "0 auto",
                  display: "flex",
                  gap: 0,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CustomDateComp
                  formValues={formValues}
                  setFormValues={setFormValues}
                  setPreview={setPreview}
                  fetchInProgress={fetchInProgress }
                  setParentFetchInProgress={setFetchInProgress}
                  setReportData={setReportData}
                  submit={submit}
                  setSubmit={setSubmit}
                  slideClass={true}
                />
              </div>
            </div>
          </Slide>
          <Slide
            direction="down"
            in={showBrandingSlider}
            mountOnEnter
            unmountOnExit
          >
            <div
              id="branding-slider"
              className={searchClasses.searchBarContainer}
              ref={brandingSliderRef}
            >
              <ExportSettingsForm
                user={user}
                setPreview={() => setPreview(!preview)}
                setParentFetchInProgress={setFetchInProgress}
                formValues={formValues}
                setFormValues={setFormValues}
                {...props}
                defaultValues={defaultValues}
                aiInProgress={aiInProgress}
                setFormValuesCheckboxes={setFormValuesCheckboxes}
                formValuesCheckboxes={formValuesCheckboxes}
                panel={"branding"}
                setReportData={setReportData}
                setSubmit={setSubmit}
                submit={submit}
                isDrawerOpen={isDrawerOpen}
                color={color}
                setColor={setColor}
                selectedFont={selectedFont}
                setSelectedFont={setSelectedFont}

              />
            </div>
          </Slide>

          <Slide
            direction="down"
            in={showThemeSlider}
            mountOnEnter
            unmountOnExit
          >
            <div
              id="theme-slider"
              className={searchClasses.searchBarContainer}
              ref={themeSliderRef}
            >
              <ExportSettingsForm
                user={user}
                setPreview={() => setPreview(!preview)}
                setParentFetchInProgress={setFetchInProgress}
                formValues={formValues}
                setFormValues={setFormValues}
                {...props}
                defaultValues={defaultValues}
                aiInProgress={aiInProgress}
                setFormValuesCheckboxes={setFormValuesCheckboxes}
                formValuesCheckboxes={formValuesCheckboxes}
                panel={"theme"}
                setReportData={setReportData}
                setSubmit={setSubmit}
                submit={submit}
                isDrawerOpen={isDrawerOpen}
                color={color}
                setColor={setColor}
                selectedFont={selectedFont}
                setSelectedFont={setSelectedFont}
                backgroundColor={backgroundColor}
                setBackgroundColor={setBackgroundColor}
                textColor={textColor}
                setTextColor={setTextColor}

              />
            </div>
          </Slide>

          {!isBuilding ? (
         <>
            <main
              className={classes.content}
              style={{
                flexGrow: 1,
                padding: "16px",
                marginLeft: 0,
                marginTop: sliderHeight,
              }}
            >
              <div className="pdf_modal_container">
                <div className="pdf_preview">
                  <div
                    className="modal__body"
                    style={{
                      height: "100%",
                      minHeight: "calc(100vh - 250px)",
                      padding: 15,
                    }}
                  >
                    <div style={{ padding: "0 20px" }}>
                      <ZoomSlider
                        zoom={zoom}
                        setZoom={setZoom}
                        disabled={!(!fetchInProgress && reportData)}
                      />
                    </div>

                    <div
                      style={{
                        marginTop: "3em",
                      }}
                    >
                      <div
                        id={"previewContainer"}
                        style={{
                          width:
                            layoutStyle && layoutStyle.width
                              ? `${new Number(layoutStyle.width) + 40}px`
                              : "100%",
                          margin: "auto",
                          transform: `scale(${(!fetchInProgress && reportData) ? getZoom() : '100%'})`,
                          filter: "blur(0px)",
                          backfaceVisibility: "hidden",
                          transformOrigin: "top center",
                        }}
                      >
                        {!fetchInProgress && reportData  ? (
                          <div>
                            <ExportView
                              ref={iframeRef}
                              headerContent={headerContent}
                              scripts={scripts}
                              headerHTML={
                                isHeaderAvailable ? <ReportHeader /> : null
                              }
                              footerHTML={
                                isFooterAvailable ? <ReportFooter /> : null
                              }
                              contentHTML={
                                editedContent ? editedContent : ReportContent
                              }
                              preview={preview}
                              searchTags={searchTags}
                              boundingBoxCoord={boundingBoxCoord}
                              setIsMapLoaded={setIsMapLoaded}
                              isMapLoaded={isMapLoaded}
                              handleMapLoad={handleMapLoad}
                              formValues={formValues}
                              formValuesCheckboxes={formValuesCheckboxes}
                              isEditMode={isEditMode}
                              onSaveChanges={handleSaveChanges}
                              layoutStyle={layoutStyle}
                              setFetchAi={setFetchAi}
                              setAiResponse={setAiResponse}
                              fetchAi={fetchAi}
                              AiResponse={AiResponse}
                              setAIInProgress={setAIInProgress}
                            
                            />
                          </div>
                        ) : (
                          <ReportLoading />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {!reportData && ReportContent}
     
                  </div>
                </div>
              </div>
            </main>
               <div>
               <Fragment>
                 {progress ? (
                   <div
                     id="progress"
                     style={{
                       padding: 20,
                       background: "#FFF",
                       position: "fixed",
                       top: "50%",
                       left: "50%",
                       transform: "translate(-50%, -50%)",
                       width: "60%",
                       height: 75,
                       border: "2px solid #171F26",
                     }}
                   >
                     <Typography
                       variant="h5"
                       noWrap
                       className={classes.drawerHeaderTitle}
                       style={{ textAlign: "center" }}
                     >
                       <FileExportIcon
                         size={32}
                         color="#780F9E"
                         style={{ marginTop: -5 }}
                       />{" "}
                       {progress}...
                     </Typography>
                   </div>
                 ) : null}
                 <div
                   style={{
                     position: "fixed",
                     bottom: 50,
                     right: 50,
                     zIndex: 9999,
                   }}
                 >
                 {reportItem && reportItem.reportType && reportItem.reportType == "video-script" ?
                 <>
                    <HeyGenExportButton 
                      iframeRef={iframeRef}
                      {...props} 
                      setAIInProgress={setAIInProgress} 
                      toggleModal={toggleModal}
                      className={classes.fab} 
                      snackOpen={snackOpen}
                      disabled={fetchInProgress || aiInProgress || fetchAi} />
                    {/* <Tooltip
                       title={
                         ext == "png"
                           ? "Export Image as PNG"
                           : `Export Report as PDF`
                       }
                     >
                    
                       <Fab
                         variant="extended"
                         size="medium"
                         color="secondary"
                         aria-label="add"
                         className={classes.fab}
                         onClick={handleCopy}
                         disabled={fetchInProgress || aiInProgress || fetchAi}
                       >
                         <FileExportIcon style={{ marginRight: 5 }} /> {` `}
                         Copy Script
                       </Fab>
                     </Tooltip> */}
                     </>: null}
                   <Tooltip
                     title={
                       ext == "png"
                         ? "Export Image as PNG"
                         : `Export Report as PDF`
                     }
                   >
                
                     <Fab
                       variant="extended"
                       size="medium"
                       color="secondary"
                       aria-label="add"
                       className={classes.fab}
                       onClick={handleExport}
                       disabled={fetchInProgress || aiInProgress || fetchAi}
                     >
                       <FileExportIcon style={{ marginRight: 5 }} /> {` `}
                       {exportInProgress && isMapLoaded
                         ? "Downloading... "
                         : ext == "png"
                         ? "Download Image"
                         : ext == "zip"
                         ? "Download Images (Zip)"
                         : reportItem && reportItem.reportType && reportItem.reportType == "video-script"
                         ? "Download Script"
                         : "Download Report"}
                     </Fab>
                   </Tooltip>
                   <Tooltip title={`Close`}>
                     <Fab
                       variant="extended"
                       size="medium"
                       color="secondary"
                       aria-label="add"
                       className={classes.fabClose}
                       onClick={() => {
                        if (sliderOpen) {
                          closeAllSliders();
                        } else {
                          toggleModal();
                          setFormValues({
                            ...formValues,
                            dateOptions: {
                              startDate: defaultDate(isBuildingReport).startDate,
                              endDate: defaultDate(isBuildingReport).endDate,
                              previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
                              previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
                              gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
                              isCustomPreviousSelected: false,
                              isPreviousSelectedClicked: false,
                              anyChangeOccured: false,
                            },
                          });
                          setIsBuilding && setIsBuilding(false);
                          setIsMedia && setIsMedia(false)
                          setReportData(null);
                          setAiResponse(null);
                          setFetchAi(false)
                          setFetchInProgress(false);
                          setReportLoaded(false)
                          console.log("modalClose");
                        }
                      }}
                       disabled={fetchInProgress || aiInProgress || fetchAi}
                     >
                       Close
                     </Fab>
                   </Tooltip>
                 </div>
               </Fragment>
             </div>
         </>
          ) : isBuilding && isBuilding =="comp" ?
          <CompPropertySelector updateBuildingReport={updateBuildingReport} {...props} setCompSettings={setCompSettings} compSettings={compSettings} />
          : isBuilding && isBuilding =="coming-soon" ?
          <PropertySelector updateBuildingReport={updateBuildingReport} {...props} setCompSettings={setCompSettings} compSettings={compSettings} />
          
          :
         <BuildingSearchSelector updateBuildingReport={updateBuildingReport} {...props}  />
      }
        </div>

       
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    searchTags: Array.isArray(state.search.searchTags)
      ? state.search.searchTags.slice().map((tag) => {
          if (
            tag.type === "neighborhood" &&
            !tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood.toLowerCase().replace(/\s+/g, "-")}_${
                tag.data.boro
              }`,
            };
          } else if (
            tag.type === "neighborhood" &&
            tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood
                .replace("manhattan", "")
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "-")}_${tag.data.boro}`,
            };
          } else return tag;
        })
      : [],
  };
};

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(searchActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportModal);
